import StudentSidebar from '../components/StudentSidebar.js';
import { useState, useEffect } from "react";
import axios from 'axios';
import { FileText } from 'lucide-react';
import { encodePathSegment } from '../utils/apiPath';

export default function StudentMaterials() {
    const [materials, setMaterials] = useState([]);

    useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/materials/student`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        setMaterials(res.data);
      } catch (err) {
        console.error("Błąd pobierania materiałów", err);
      }
    };
    fetchMaterials();
  }, []);

    return (
        <div className="student-dashboard-panel">
            {/* Sidebar */}
            <StudentSidebar />
            {/* Main Content */}
            <div className='main-content'>
                {/* Header */}
                <div className='header'>
                    <h1 className='header-title'>Materiały</h1>
                </div>
                {/* Dashboard Content */}
                <div className="dashboard">
                     <div className='student-header'>
                        <h1 className='student-title'>Materiały</h1>
                        <p className="student-subheading">Zasoby edukacyjne i dokumenty</p>
                     </div>
                     <div className="grades-card">
                        <div className="grades-card-content">
                            <h3>Pliki i dokumenty</h3>
                        </div>
                        {/* File list */}
                        <div className="file-list-grid file-grid-cols-3">
                            {materials.length === 0 && <p>Brak materiałów</p>}
                                {materials.map(({ module, files }) =>
                                    files.map((file, idx) => (
                                        <div key={`${module.module_id}-${idx}`} className="file-card">
                                            <div className="file-icon">
                                                <FileText size={20} color="#16a34a" />
                                                <span className="file-extension">
                                                    {file.name.split('.').pop().toUpperCase()}
                                                </span>
                                            </div>
                                            <h2 className="file-module">{module.module_name}</h2>
                                            <h4 className="file-name">{file.name}</h4>
                                            <p className="file-size">{(file.size / (1024 * 1024)).toFixed(2)} MB</p>
                                            <button
                                                className="btn button-secondary button-download"
                                                onClick={() => {
                                                    const encodedGroup = encodePathSegment(module.group_code);
                                                    const encodedFileName = encodeURIComponent(file.name);
                                                    const url = `${process.env.REACT_APP_API_URL}/materials/download/${encodedGroup}/${module.module_id}/${encodedFileName}`;
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.setAttribute('download', file.name);
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    link.remove();
                                                }}
                                            >
                                                Pobierz
                                            </button>
                                        </div>
                                    ))
                                )}
                        </div>
                     </div>
                </div>
            </div>
        </div>
    );
}